
import { loadLazyImages } from "../utilities/globalUtilities";
/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    if (!$(".tracking-consent").data("caonline")) {
        return;
    }

    const urlContent = $(".tracking-consent").data("url");
    const urlAccept = $(".tracking-consent").data("accept");
    const urlReject = $(".tracking-consent").data("reject");
    const textYes = $(".tracking-consent").data("accepttext");
    const textNo = $(".tracking-consent").data("rejecttext");
    const textHeader = $(".tracking-consent").data("heading");
    const consentModalId = "consent-tracking";

    const modalHeaderHTML =
    `
        <div class="modal-header p-0">
            <h3 class="modal-title sr-only pwc-h3" id="${consentModalId}-label">${textHeader}</h3>
        </div>
    `;

    const modalBodyHTML =
    `
        <div class="modal-body text-center">
            <div class="row no-gutters justify-content-center">
                <div class="col-12 col-sm-11 text-center">
                    <p class="modal-text-content js-consent-text p-sm-0"></p>
                </div>
                <div class="col-12 d-flex d-sm-block consent-confirmation-btns">
                    <button class="button button--secondary decline" data-url="${urlReject}" data-dismiss="modal">
                        ${textNo}
                    </button>
                    <button class="button button--primary affirm" data-url="${urlAccept}" data-dismiss="modal">
                        ${textYes}
                    </button>
                </div>
            </div>
        </div>
    `;

    const modalHTML =
    `
        <div class="modal" id="${consentModalId}" tabindex="-1" role="dialog" aria-labelledby="${consentModalId}-label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered ct-modal-size--small ct-modal-small-buttons" role="document">
                <div class="modal-content ct-modal-dialog-white">
                    ${modalHeaderHTML}
                    ${modalBodyHTML}
                </div>
            </div>
        </div>
    `;

    $("body").append(modalHTML);
    $("#consent-tracking").modal({
        backdrop: "static",
        show: true
    });


    $.ajax({
        url: urlContent,
        type: "get",
        dataType: "html",
        success: function (response) {
            $("#consent-tracking").find(".js-consent-text").html(response);
            //GTM logic - Start
            const $innerContentAsset = $(".js-consent-text").find(".content-asset");
            const $assetParagraph = $innerContentAsset.length ? $innerContentAsset.find("p") : null;
            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                detail: {
                    "success": true,
                    "messageContent": $assetParagraph ? $assetParagraph.text() : "",
                }
            }));
            //GTM logic - End
        },
        error: function () {
            $("#consent-tracking").remove();
        }
    });

    $("#consent-tracking .consent-confirmation-btns button").click(function (e) {
        e.preventDefault();
        const url = $(this).data("url");
        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function () {
                $("#consent-tracking").modal("hide").remove();
                $.spinner().stop();
            },
            error: function () {
                $("#consent-tracking").modal("hide").remove();
                $.spinner().stop();
            }
        });
    });
}

function cookieBotButtonClick() {
    $(".CybotCookiebotDialogActive").on("click", "#CybotCookiebotDialogBodyButtonsWrapper > button", function (e) {
        var buttonClicked = e.currentTarget;
        if (buttonClicked) {
            var url;
            var cookieBotConsent = $("#Cookiebot");
            switch (buttonClicked.id) {
                case "CybotCookiebotDialogBodyButtonDecline":
                    url = cookieBotConsent.data("reject-url");
                    break;
                case "CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection":
                    url = $("#CybotCookiebotDialogBodyLevelButtonMarketingInline").is(":checked") ? cookieBotConsent.data("accept-url") : cookieBotConsent.data("reject-url");
                    break;
                case "CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll":
                    url = cookieBotConsent.data("accept-url");
                    break;
            }
    
            if (url) {
                $.ajax({
                    url: url,
                    type: "get",
                    dataType: "json"
                });
            }
        }
    });
}

const showPersonalAdvConsentModal = () => {
    const $personalAdvModal = $("#consent-personal-advertisement-modal");
    if (!$personalAdvModal.length) return;
    
    const $personalAdvModalBody = $personalAdvModal.find(".js-modal-body");
    const getModalContentURL = $(".js-mod-url").data("url");
    if (!getModalContentURL) return;

    $.spinner().start();

    $.ajax({
        url: getModalContentURL,
        type: "get",
        dataType: "html",
        data: {
            template: $personalAdvModal.data("mod-template-path")
        },
        success: data => {
            $personalAdvModalBody.html(data);
            if ($personalAdvModalBody.find("input#personaladvertisement-modal").length == 0) {
                $.spinner().stop();
                return;
            }
            $.spinner().stop();
            loadLazyImages(`#${$personalAdvModal.id}`);
            $personalAdvModal.find(".js-personal-adv-data-processing").hide();

            $(".js-personal-adv-button").on("click", e => {
                e.preventDefault();
                personalAdvModalButtonEvent(e);
            });

            $personalAdvModal.find(".js-personal-adv-goto-processing-data").on("click", () => {
                $personalAdvModal.find(".js-personal-adv").hide();
                $personalAdvModal.find(".js-personal-adv-data-processing").show();
            });

            $personalAdvModal.find(".js-personal-adv-backto").on("click", () => {
                $personalAdvModal.find(".js-personal-adv").show();
                $personalAdvModal.find(".js-personal-adv-data-processing").hide();
            });
            
            $personalAdvModal.modal("show");
        },
        error: () => {
            $.spinner().stop();
        }
    });
};

const personalAdvModalButtonEvent = (e) => {
    e.preventDefault();
    const $personalAdvModal = $("#consent-personal-advertisement-modal");
    const consentForm = document.querySelector(".ct-consent-personal-advertisement-form");
    const actionUrl = consentForm.action;
    const btnValue = e.currentTarget.dataset.value == "true";

    const formData = $(consentForm).serializeArray();
    formData.push({name: "isPersonalAdvertisement", value: btnValue});

    if (actionUrl) {
        $.ajax({
            url: actionUrl,
            method: "POST",
            dataType: "json",
            data: formData,
            success: function (response) {
                if (response && response.success) {
                    $personalAdvModal.modal("hide");
                    window.sessionStorage.removeItem("mailingUserId");
                    require("../kevel/audience").deleteMailingAnonIdCookie();
                    document.dispatchEvent(new CustomEvent("dataLayer.interconnection", {
                        detail: {
                            "interconnection": btnValue,
                            "mailingUserId": response.mailingUserId
                        }
                    }));
                    location.reload();
                }
            }
        });
    }
};

module.exports = function () {
    if ($(".consented").length === 0 && $(".tracking-consent").hasClass("api-true")) {
        showConsentModal();
    }

    if ($(".tracking-consent").hasClass("api-true")) {
        $(".tracking-consent").click(function () {
            showConsentModal();
        });
    }


    if ($(".tracking-personal-advertising-consent").length != 0) {
        showPersonalAdvConsentModal();
    }

    var waitForEl = function (selector, callback) {
        if (jQuery(selector).length) {
            callback();
        } else {
            setTimeout(function () {
                waitForEl(selector, callback);
            }, 100);
        }
    };

    if (window.Cookiebot && !window.Cookiebot.consented && !window.Cookiebot.declined) {
        waitForEl("#CybotCookiebotDialog", function () {
            cookieBotButtonClick();
        });
    }

    $("#cookieBotChangeConsent").on("click", function () {
        waitForEl("#CybotCookiebotDialog.CybotCookiebotDialogActive", function () {
            cookieBotButtonClick();
        });
    });
};
